import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.Fragment>
    <App />
  </React.Fragment>
);

// Enregistrer le service worker pour activer les fonctionnalités PWA uniquement en production
// Désenregistrer en développement pour éviter les problèmes de cache
if (import.meta.env.PROD) {
  serviceWorkerRegistration.register({
    onSuccess: (registration) => {
      console.log('✅ PWA installée avec succès!');
    },
    onUpdate: (registration) => {
      console.log('🔄 Mise à jour PWA détectée!');
    }
  });
} else {
  serviceWorkerRegistration.unregister();
}
